import { WebSocketEntityUpdateInterface } from '@/utils/websocket-entity-updates/webSocketEntityUpdates.types';
import { store } from '@/redux/store';
import { ENTITY_OPERATION_TYPES } from '@/utils/websocket-entity-updates/webSocketEntityUpdates.constants';
import { getGlyphs } from '@/redux/glyphs/glyphs.thunks';

/**
 * Keeps the list of glyphs in sync with the server. A glyph uploaded by one user has to become
 * available to everyone editing the same project, otherwise the image pickers keep showing the
 * list fetched when the map was opened. Glyphs are only ever added - the backend does not support
 * updating or removing them - so there is nothing to invalidate in the glyph image cache.
 */
export default async function processGlyph({
  data,
}: {
  data: WebSocketEntityUpdateInterface;
}): Promise<void> {
  const { dispatch } = store;

  if (data.type === ENTITY_OPERATION_TYPES.ENTITY_CREATED) {
    dispatch(getGlyphs());
  }
}
